import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressSummaryPage from './ProgressSummaryPage';

const ProgressSummaryPageWrapper = () => {
  const navigate = useNavigate();

  return (
    <ProgressSummaryPage 
      navigate={navigate}
    />
  );
};

export default ProgressSummaryPageWrapper;
